import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function LatestArticles() {
  const latestArticles = articles.slice(0, 8);

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="mb-8">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
              <i className="ri-timer-flash-line text-primary-500 mr-2"></i>
              最新爆料
            </h2>
            <p className="text-sm text-foreground-600 mt-1">实时更新，不错过任何一个大瓜</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {latestArticles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="group flex flex-col sm:flex-row gap-4 p-5 bg-background-50 border border-background-200 rounded-xl hover:border-primary-300 transition-all duration-300 cursor-pointer"
              >
                <div className="relative w-full sm:w-48 h-36 sm:h-32 flex-shrink-0 rounded-lg overflow-hidden">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    title={article.title}
                  />
                  {article.isHot && (
                    <div className="absolute top-2 left-2">
                      <span className="px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
                        热门
                      </span>
                    </div>
                  )}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2 flex-wrap">
                    <span className="whitespace-nowrap">{article.publishDate}</span>
                    <span className="whitespace-nowrap">{article.readTime}阅读</span>
                    <span className="whitespace-nowrap">{article.author}</span>
                  </div>
                  <h3 className="text-foreground-950 font-semibold text-base mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors leading-snug">
                    {article.title}
                  </h3>
                  <p className="text-foreground-600 text-sm line-clamp-2 leading-relaxed">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center gap-3 mt-3 flex-wrap">
                    {article.tags.slice(0, 3).map((tag) => (
                      <span
                        key={tag}
                        className="px-2 py-0.5 bg-background-100 text-foreground-600 text-xs rounded-md whitespace-nowrap"
                      >
                        #{tag}
                      </span>
                    ))}
                  </div>
                </div>
              </Link>
            ))}
          </div>

          <div className="mt-8 text-center">
            <Link
              to="/category/all"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 text-sm font-medium rounded-lg hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              查看更多爆料 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}